















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookTabs extends Vue {
  get tabs() {
    return [
      {
        label: 'First tab',
        key: 'first',
        icon: 'fas fa-list',
      },
      {
        label: 'Second tab',
        key: 'second',
        icon: 'fas fa-pen',
      },
    ]
  }
}
